var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.059 8.059 0 18 0s18 8.059 18 18-8.059 18-18 18S0 27.941 0 18z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.197 13.555a2.438 2.438 0 0 0-1.697-1.743c-1.497-.412-7.502-.412-7.502-.412s-6.004 0-7.5.412A2.438 2.438 0 0 0 8.8 13.555c-.402 1.538-.402 4.745-.402 4.745s0 3.208.402 4.745c.22.849.871 1.517 1.697 1.743 1.497.412 7.501.412 7.501.412s6.005 0 7.502-.412a2.438 2.438 0 0 0 1.697-1.742c.401-1.538.401-4.746.401-4.746s0-3.207-.4-4.745z",
    fill: "red"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 21.6v-6l4.8 3-4.8 3z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.4690f1baf922981ce7e6bf36b3f24299.svg";
export { ForwardRef as ReactComponent };